import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import videoSkeletonStyles from '../skeleton/video-skeleton.styles';
export default css `
  ${componentStyles}

  :host {
    flex-grow: 1;
    background-color: var(--p-section-bg);

    --search-results-padding: 1.25rem;
  }

  .search {
    padding: var(--p-gap) 0 var(--p-section-padding);
    outline: none;
  }

  .pages-container {
    --p-container-width: var(--p-text-max-width);
  }

  .container {
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
  }

  .results {
    display: grid;
    gap: var(--p-video-grid-gap);
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-default-width), 1fr));
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .video-item-layout-card .results {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-card-width), 1fr));
  }

  .video-item-layout-portrait .results {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-portrait-width), 1fr));
  }

  .video-item-layout-full .results {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-full-width, 100%), 1fr));
  }

  .results.list {
    display: block;
  }

  .results.list li {
    border-bottom: 1px solid var(--p-border);
    padding: var(--search-results-padding) 0;
  }

  .results.list li:first-child {
    padding-top: 0;
  }

  .results.list li:last-child {
    border-bottom: none;
  }

  .results.list li a {
    color: var(--p-link-text-color);
    text-decoration: var(--p-link-text-decoration);
  }

  .results.list li a:hover {
    color: var(--p-link-text-color-hover);
    text-decoration: var(--p-link-text-decoration-hover);
  }

  .results.list h3 {
    font-family: var(--p-h5-font);
    font-size: var(--p-h5-font-size);
    font-weight: var(--p-h5-font-weight);
    font-style: var(--p-h5-font-style);
    line-height: var(--p-h5-line-height);
    text-transform: var(--p-h5-transform);
    letter-spacing: var(--p-h5-letter-spacing);
    color: var(--p-h5-color, var(--p-heading-color));
    margin: 0;
  }

  .results.list p {
    font-family: var(--p-font);
    line-height: var(--p-body-line-height);
    font-style: var(--p-body-font-style);
    font-size: var(--p-body-font-size);
    font-weight: var(--p-body-font-weight);
    color: var(--p-text-color);
    letter-spacing: var(--p-body-letter-spacing);
    margin: var(--p-h5-margin-bottom) 0 0 0;
  }

  h1 {
    font-family: var(--p-h3-font);
    font-size: var(--p-h3-font-size);
    font-weight: var(--p-h3-font-weight);
    font-style: var(--p-h3-font-style);
    line-height: var(--p-h3-line-height);
    text-transform: var(--p-h3-transform);
    letter-spacing: var(--p-h3-letter-spacing);
    color: var(--p-h3-color, var(--p-heading-color));
    margin: 0 0 var(--search-results-padding);
  }

  h2 {
    font-family: var(--p-h4-font);
    font-size: var(--p-h4-font-size);
    font-weight: var(--p-h4-font-weight);
    font-style: var(--p-h4-font-style);
    line-height: var(--p-h4-line-height);
    text-transform: var(--p-h4-transform);
    letter-spacing: var(--p-h4-letter-spacing);
    margin: 0 0 var(--p-h4-margin-bottom);
    color: var(--p-h4-color, var(--p-heading-color));
  }

  .empty {
    font-family: var(--p-body-font);
    font-size: var(--p-body-font-size);
    font-weight: var(--p-body-font-weight);
    font-style: var(--p-body-font-style);
    line-height: var(--p-body-line-height);
    letter-spacing: var(--p-body-letter-spacing);
    color: var(--p-text-color);
    margin: 0;
    opacity: var(--p-text-meta-opacity);
  }

  :host([dark]) {
    --p-section-bg: var(--p-bg-dark);
    --p-text-color: var(--p-text-color-light);
  }

  .files-result {
    margin-bottom: var(--p-gap);
  }

  ${videoSkeletonStyles}
`;
